import React from "react";
import { Car } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { TESLA_FULL_REAR_PREMIUM } from "../../constants/pricingTiers";

// Tesla Model 3 Rear Glass Selection Modal
// Tesla Model 3 has a complex rear window - customers can choose half or full rear glass tinting
const TeslaRearGlassModal = ({ isOpen, onClose, service, onSelectHalf, onSelectFull, basePrice }) => {
  if (!service) return null;
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-saturn-slate border-slate-700 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="font-orbitron text-xl text-white flex items-center gap-2">
            <Car className="w-5 h-5 text-saturn-orange" />
            Tesla Model 3 - Rear Glass Option
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Tesla Model 3 has a unique rear window design. Choose your preferred coverage.
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex flex-col gap-4 mt-4">
          {/* Half Back Glass - Standard */}
          <button
            onClick={onSelectHalf}
            className="glass rounded-xl p-4 text-left hover:border-saturn-orange transition-all group"
            data-testid="tesla-modal-half-rear"
          >
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <h4 className="font-rajdhani font-bold text-white group-hover:text-saturn-orange text-lg">
                  Half Back Glass
                </h4>
                <p className="text-slate-400 text-sm mt-1">
                  Standard rear section tint - covers the main rear window area
                </p>
                <div className="mt-2 inline-block px-2 py-1 bg-green-500/20 text-green-400 text-xs rounded font-rajdhani">
                  STANDARD OPTION
                </div>
              </div>
              <div className="text-right ml-4">
                <span className="text-saturn-orange font-orbitron font-bold text-xl">
                  EUR{basePrice}
                </span>
                <p className="text-slate-500 text-xs">No extra charge</p>
              </div>
            </div>
          </button>
          
          {/* Full Rear Glass - Premium */}
          <button
            onClick={onSelectFull}
            className="glass rounded-xl p-4 text-left hover:border-blue-500 transition-all group border-blue-500/30"
            data-testid="tesla-modal-full-rear"
          >
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <h4 className="font-rajdhani font-bold text-white group-hover:text-blue-400 text-lg">
                  Full Rear Glass
                </h4>
                <p className="text-slate-400 text-sm mt-1">
                  Complete coverage including the extended roof glass section
                </p>
                <div className="mt-2 inline-block px-2 py-1 bg-blue-500/20 text-blue-400 text-xs rounded font-rajdhani">
                  FULL COVERAGE
                </div>
              </div>
              <div className="text-right ml-4">
                <span className="text-blue-400 font-orbitron font-bold text-xl">
                  EUR{basePrice + TESLA_FULL_REAR_PREMIUM}
                </span>
                <p className="text-saturn-orange text-xs font-rajdhani">+EUR{TESLA_FULL_REAR_PREMIUM} premium</p>
              </div>
            </div>
          </button>
        </div>
        
        <div className="mt-4 p-3 bg-slate-800/50 rounded-lg">
          <p className="text-slate-400 text-xs">
            <strong className="text-slate-300">Note:</strong> Tesla Model 3's panoramic rear glass extends further than traditional vehicles. 
            The full rear glass option ensures complete coverage of this unique design.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TeslaRearGlassModal;
